<template>
  <!-- <section class="flex flex-col items-center justify-center min-h-[60vh]">
    <h1 class="text-4xl font-bold mb-4">Bienvenido a Soleando</h1>
    <p class="text-lg text-base-content">
      Gestiona tu plataforma de manera sencilla y eficiente.
    </p>
    <NuxtLink to="/admin" class="btn btn-primary mt-4">
      Acceder al panel de administración
    </NuxtLink>
  </section> -->
  <!-- HERO section -->
  <section
    class="hero min-h-[60vh] bg-gradient-to-r from-orange-600 to-yellow-500 text-white relative overflow-hidden"
    style="
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
        url('/hero.jpg');
      background-size: cover;
      background-position: bottom;
    "
  >
    <div class="hero-content text-center z-10">
      <div class="max-w-md">
        <h1 class="text-6xl font-bold mb-4">Soleando</h1>
        <p class="text-xl mb-8">Encuentra tu próximo gran viaje por España</p>
      </div>
    </div>
    <!-- Overlay -->
    <div class="absolute inset-0 bg-black/40"></div>
  </section>

  <!-- Filters -->
  <section class="filters w-full flex justify-center -mt-16 relative z-20">
    <div class="w-full max-w-6xl bg-white rounded-lg shadow-2xl px-6 py-8 mx-4">
      <h2 class="text-2xl font-bold mb-6 text-center">
        Encuentra tu viaje ideal
      </h2>
      <div class="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
        <!-- Destination Filter -->
        <div class="form-control w-full">
          <label class="label">
            <span class="label-text font-semibold">Destino de inicio</span>
          </label>
          <select
            v-model="filters.destination"
            class="select select-bordered w-full"
            @change="filterTrips"
          >
            <option value="">Todos los destinos</option>
            <option
              v-for="destination in destinations"
              :key="destination.id"
              :value="destination.id"
            >
              {{ destination.name }}
            </option>
          </select>
        </div>

        <!-- Duration Filter -->
        <div class="form-control w-full">
          <label class="label">
            <span class="label-text font-semibold">Duración</span>
          </label>
          <select
            v-model="filters.duration"
            class="select select-bordered w-full"
            @change="filterTrips"
          >
            <option value="">Cualquier duración</option>
            <option value="1-3">1-3 días</option>
            <option value="4-7">4-7 días</option>
            <option value="8+">8+ días</option>
          </select>
        </div>

        <!-- Date Filter -->
        <div class="form-control w-full">
          <label class="label">
            <span class="label-text font-semibold">Fecha</span>
          </label>
          <input
            v-model="filters.date"
            type="date"
            class="input input-bordered w-full"
            @change="filterTrips"
          />
        </div>

        <!-- Search Button -->
        <div class="form-control w-full flex justify-end">
          <label class="label">
            <span class="label-text">&nbsp;</span>
          </label>
          <button @click="filterTrips" class="btn btn-primary w-full">
            Buscar viajes
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- Trips Section -->
  <section class="trips py-16 bg-base-100 pt-40 -mt-30">
    <div class="container mx-auto px-4">
      <h2 class="text-3xl font-bold text-center mb-12">
        {{ hasActiveFilters ? "Viajes encontrados" : "Viajes destacados" }}
      </h2>

      <!-- Trips Grid -->
      <div
        v-if="displayedTrips.length > 0"
        class="grid grid-cols-1 lg:grid-cols-3 gap-8"
      >
        <TripCard v-for="trip in displayedTrips" :key="trip.id" :trip="trip" />
      </div>

      <!-- Empty state -->
      <div v-else class="text-center py-12">
        <p class="text-xl text-base-content/70 mb-6">
          {{
            allTrips.length === 0
              ? "No hay viajes disponibles"
              : "No se encontraron viajes con los filtros seleccionados"
          }}
        </p>
        <button
          v-if="allTrips.length > 0"
          @click="clearFilters"
          class="btn btn-outline"
        >
          Limpiar filtros
        </button>
      </div>

      <!-- Load more buttons - only show when no filters are active -->
      <div
        v-if="!hasActiveFilters && displayedTrips.length > 0"
        class="text-center mt-12 space-x-4"
      >
        <button
          v-if="canLoadMore"
          @click="loadMoreTrips"
          class="btn btn-outline"
        >
          Ver más viajes
        </button>
        <NuxtLink to="/trips" class="btn btn-primary">
          Mostrar todos los viajes
        </NuxtLink>
      </div>
    </div>
  </section>

  <!-- Blog Section -->
  <section class="blog py-16 bg-base-200">
    <div class="container mx-auto px-4">
      <h2 class="text-3xl font-bold text-center mb-12">
        Últimas entradas del blog
      </h2>

      <div
        v-if="blogArticles.length > 0"
        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
      >
        <BlogCard
          v-for="article in blogArticles"
          :key="article.id"
          :article="article"
        />
      </div>

      <div v-else class="text-center py-12">
        <p class="text-xl text-base-content/70">
          No hay entradas de blog disponibles
        </p>
      </div>

      <div class="text-center mt-12">
        <NuxtLink to="/blog" class="btn btn-primary">
          Ver todas las entradas
        </NuxtLink>
      </div>
    </div>
  </section>
</template>

<script setup>
definePageMeta({
  layout: "landing",
});

// Server-side data fetching with error handling
let allTrips = [];
let allDestinations = [];
let blogArticles = [];

try {
  allTrips = (await $fetch("/api/trips")) || [];
} catch (error) {
  console.error("Error fetching trips:", error);
}

try {
  allDestinations = (await $fetch("/api/trips/customize/destinations")) || [];
} catch (error) {
  console.error("Error fetching destinations:", error);
}

// Fetch blog articles using Strapi
try {
  const { getArticles } = useStrapi();
  const blogResponse = await getArticles({ pageSize: 3 });
  blogArticles = blogResponse?.data || [];
} catch (error) {
  console.error("Error fetching blog articles:", error);
}

// Reactive data - ensure server/client consistency
const tripsToShow = ref(6); // Initially show 6 trips
const filters = ref({
  destination: "",
  duration: "",
  date: "",
});

// Computed properties
const destinations = computed(() => {
  // Get unique destination IDs from trips
  const tripDestinationIds = new Set();

  allTrips.forEach((trip) => {
    // Use the destination_start from the trip (populated by API)
    if (trip.destination_start?.id) {
      tripDestinationIds.add(trip.destination_start.id);
    }
    // Fallback: check first segment if destination_start not populated
    else if (trip.segments && trip.segments.length > 0) {
      const firstSegment = trip.segments[0];
      if (firstSegment?.destination_start) {
        tripDestinationIds.add(firstSegment.destination_start);
      }
    }
  });

  // Filter destinations to only include those that have trips
  const filteredDestinations = allDestinations.filter((dest) =>
    tripDestinationIds.has(dest.id)
  );

  return filteredDestinations;
});

const hasActiveFilters = computed(() => {
  return (
    filters.value.destination || filters.value.duration || filters.value.date
  );
});

// Make filteredTrips computed to ensure consistency
const filteredTrips = computed(() => {
  let filtered = [...allTrips];

  // Filter by destination
  if (filters.value.destination) {
    filtered = filtered.filter((trip) => {
      // Use the destination_start from the trip (populated by API)
      if (trip.destination_start?.id) {
        return trip.destination_start.id === filters.value.destination;
      }
      // Fallback: check first segment if destination_start not populated
      else if (trip.segments && trip.segments.length > 0) {
        const firstSegment = trip.segments[0];
        return firstSegment?.destination_start === filters.value.destination;
      }
      return false;
    });
  }

  // Filter by duration
  if (filters.value.duration) {
    filtered = filtered.filter((trip) => {
      const duration = calculateTripDuration(trip);
      switch (filters.value.duration) {
        case "1-3":
          return duration >= 1 && duration <= 3;
        case "4-7":
          return duration >= 4 && duration <= 7;
        case "8+":
          return duration >= 8;
        default:
          return true;
      }
    });
  }

  // Filter by date availability
  if (filters.value.date) {
    filtered = filtered.filter((trip) => {
      return isDateAvailable(trip, new Date(filters.value.date));
    });
  }

  return filtered;
});

const displayedTrips = computed(() => {
  if (hasActiveFilters.value) {
    // Show all filtered results when filters are active
    return filteredTrips.value;
  } else {
    // Show limited trips when no filters
    return filteredTrips.value.slice(0, tripsToShow.value);
  }
});

const canLoadMore = computed(() => {
  return (
    !hasActiveFilters.value &&
    displayedTrips.value.length < filteredTrips.value.length
  );
});

const hasMoreTrips = computed(() => {
  return (
    !hasActiveFilters.value && displayedTrips.value.length < allTrips.length
  );
});

// Filter functionality - now just a trigger since filteredTrips is computed
const filterTrips = () => {
  // The filtering happens automatically via computed property
  // This function is kept for backward compatibility with UI
};

const clearFilters = () => {
  filters.value = {
    destination: "",
    duration: "",
    date: "",
  };
  tripsToShow.value = 6; // Reset to initial count
};

// Load more functionality
const loadMoreTrips = () => {
  tripsToShow.value += 3;
};

// Helper functions
const calculateTripDuration = (trip) => {
  if (trip?.segments && Array.isArray(trip.segments)) {
    return trip.segments.reduce((total, segment) => {
      return total + (segment?.duration || 1);
    }, 0);
  }
  return 1;
};

const isDateAvailable = (trip, selectedDate) => {
  // Simple availability check based on start/end months
  if (!trip.start_month || !trip.end_month) return true;

  const selectedMonth = selectedDate.getMonth() + 1;

  if (trip.start_month <= trip.end_month) {
    // Same year span
    return selectedMonth >= trip.start_month && selectedMonth <= trip.end_month;
  } else {
    // Cross-year span
    return selectedMonth >= trip.start_month || selectedMonth <= trip.end_month;
  }
};

// SEO and meta
useHead({
  title: "Soleando - Encuentra tu próximo gran viaje por el desierto",
  meta: [
    {
      name: "description",
      content:
        "Descubre increíbles viajes por el desierto con Soleando. Encuentra tu aventura perfecta con nuestros filtros personalizados y explora destinos únicos.",
    },
    {
      property: "og:title",
      content: "Soleando - Viajes por el desierto",
    },
    {
      property: "og:description",
      content:
        "Descubre increíbles viajes por el desierto con Soleando. Encuentra tu aventura perfecta con nuestros filtros personalizados.",
    },
    {
      property: "og:type",
      content: "website",
    },
  ],
});
</script>

<style scoped>
.hero {
  background-attachment: fixed;
}

@media (max-width: 768px) {
  .hero {
    background-attachment: scroll;
  }
}
</style>
